
export const addNewMerchant = "/auth/partner/create/merchant";
export const getMerchants = (id) => `/auth/partner/${id}/merchants`;
export const getSingleMerchant = `/auth/users/partner/merchant/profile`;
export const getSingleMerchantWallet = (id) =>
  `/auth/partner/merchant/${id}/wallet/balance`;
export const getSingleMerchantWalletInflow = (id) =>
  `/reports/transactions/merchant/${id}/wallet/inflow`;
export const getSingleMerchantTransactions = `/reports/transactions/partner/merchant`